import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { SimpleModal } from '@livable/saas-react-components';
import { SubscriptionModalContent } from './content';
export const SubscriptionModal = observer(function SubscriptionModal(_ref) {
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    mode = _ref.mode,
    subscription = _ref.subscription,
    onSave = _ref.onSave,
    _ref$isSubmitting = _ref.isSubmitting,
    isSubmitting = _ref$isSubmitting === void 0 ? false : _ref$isSubmitting;
  const handleClose = () => {
    onClose();
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose,
    title: mode === 'edit' ? 'Edit Subscription' : 'Create Subscription'
  }, /*#__PURE__*/React.createElement(Box, {
    component: "div",
    display: "block"
  }, /*#__PURE__*/React.createElement(SubscriptionModalContent, {
    isOpen: isOpen,
    onClose: onClose,
    mode: mode,
    subscription: subscription,
    onSave: onSave,
    isSubmitting: isSubmitting
  })));
});